var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product"},[_c('h4',[_vm._v(_vm._s(_vm.name))]),_vm._t("default"),_c('div',{staticClass:"product-url"},[_c('a',{staticClass:"btn btn-primary btn-lg",attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.callToAction))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }